import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import RazaEventsMissingSadaratList from "./RazaEventsMissingSadaratList";

export default {
  list: RazaEventsMissingSadaratList,
  icon: PersonSearchIcon,
  label: "Allocate sadarat",
  options: { label: "Allocate sadarat" },
  name: "razaEventsMissingSadarat",
};
